import { collection, doc, getDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { Page } from "../types";

type Params = { brandId: string; pageId: string };

export const getPageDetails = async ({
  brandId,
  pageId,
}: Params): Promise<Page | null> => {
  const collectionRef = collection(db, `brands/${brandId}/pages`);
  const pageSnap = await getDoc(doc(collectionRef, pageId));

  if (!pageSnap.exists()) {
    return null;
  }
  return { ...pageSnap.data(), id: pageSnap.id } as Page;
};
